import * as d3 from 'd3';

export const fieldAccessibilityColorScale = d3
  .scaleSequential(d3.interpolateRdYlGn)
  .domain([-1, 1]);

export function getFieldAccessibilityColor(value) {
  return fieldAccessibilityColorScale(value);
}
